var exports = {
  "n": "x112a1f60--c40281--link",
};

module.exports = exports;
